// extracted by mini-css-extract-plugin
export default {"transactionActivity":"styles_transactionActivity__DHiGi","transactionActivityWrapper":"styles_transactionActivityWrapper__5mmqX"};